import React, { useCallback } from 'react'

import FilterChip from 'Pods/SearchPage/Components/Shared/FilterChip/FilterChip'
import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { togglePersonalFilter } from 'Pods/SearchPage/Store/actions/moreFilters'
import { PERSONAL_FILTER } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function WishListChip() {
  const translate = useTranslate()

  const isChecked = useSearchPageStore(
    state => (state.personalFilters ?? EMPTY_ARRAY).includes(PERSONAL_FILTER.WISH_LIST_ONLY),
  )
  const trackFilterSelect = useTrackFilterSelect()

  const handleChange = useCallback((nextChecked) => {
    if (nextChecked) trackFilterSelect(FILTER_NAME.PERSONAL, PERSONAL_FILTER.WISH_LIST_ONLY)
    togglePersonalFilter(PERSONAL_FILTER.WISH_LIST_ONLY, nextChecked)
  }, [trackFilterSelect])

  return (
    <FilterChip
      id="quick-filter-wish_list"
      label={translate('search_page.filters.quick_filters.in_my_wish_list')}
      isChecked={isChecked}
      onChange={handleChange}
      // Figma 538:27797 / 3217:85369 (640) drop the personal chips from the row; the drawer keeps them.
      isHiddenAtSm
    />
  )
}

export default WishListChip
